// Single source of truth for reading the auth token.
// The token may be in sessionStorage (no "remember me") or localStorage ("remember me" on).
export const getToken = () =>
  sessionStorage.getItem("token") || localStorage.getItem("token");
